var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gl-dropdown-item',{attrs:{"href":_vm.monitoringUrl,"rel":"noopener noreferrer nofollow","target":"_blank"}},[_vm._v("\n  "+_vm._s(_vm.$options.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }